import React from 'react';
import { Navigate } from 'react-router-dom';
import PddProjectListHome from "./PddProjectListHome"
import { pddRoot } from "../../../../utils/defaultValues";
import IntlMessages from "../../../../utils/IntlMessages";


const ProjectListRouteConfig = {
	routes: [
		{
			path: `${pddRoot}/project-list`,
			exact: true,
			name: <IntlMessages id={"menu.project-list"}/>,
			element: <PddProjectListHome/>,
			auth: [],
		}
	]
};
export default ProjectListRouteConfig;
